import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { UiTheme } from '../models/ui-theme.model';

@Injectable({
    providedIn: 'root',
})
export class UiThemeService {
    private _theme: UiTheme;
    private readonly themeClassPrefix: string = 'theme-';

    constructor(@Inject(DOCUMENT) private document: Document) {}

    set theme(theme: UiTheme) {
        this._theme = theme;
        this.applyThemeClassToBody(theme);
    }

    get theme(): UiTheme {
        return this._theme;
    }

    determineAndSetTheme(): void {
        this.theme = 'dark';
    }

    private applyThemeClassToBody(theme: UiTheme) {
        // Remove all other themes
        Array.from(document.body.classList).forEach((className: string) => {
            if (className.indexOf(this.themeClassPrefix) > -1) {
                this.document.body.classList.remove(className);
            }
        });
        this.document.body.classList.add(this.themeClassPrefix + theme);
    }
}
